import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';

import SharedCollections from '@/features/public/components/PublicCollections';
import SharedCollectionNote from '@/features/public/components/PublicCollectionNote';
import SharedCollectionDetail from '@/features/public/components/PublicCollectionDetail';
import SharedCollectionDetailLayout from '@/features/public/components/CollectionDetailLayout';
import CollectionMenu from '@/features/collections/components/CollectionMenu';

// Lazy-loaded components
const SharedPage = lazy(() => import('@/pages/SharedPage'));

// Loading component for Suspense
const PageLoader = () => null;

export default function SubdomainRoutes() {
  return (
    <Routes>
      {/* Redirect root to shared */}
      <Route index element={<Navigate to="/shared" replace />} />

      {/* Shared routes with prefix */}
      <Route path="/shared" element={<SharedCollections />} />

      {/* Individual shared page */}
      <Route path="/shared/page/:pageId" element={<SharedPage />} />

      {/* Shared collection routes with layout */}
      <Route
        path="/shared/:collectionId"
        element={
          <SharedCollectionDetailLayout Menu={<CollectionMenu enableSync={false} />}>
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </SharedCollectionDetailLayout>
        }
      >
        <Route index element={<SharedCollectionDetail />} />
        <Route path="page/:pageId" element={<SharedCollectionNote />} />
      </Route>

      {/* Catch-all route for invalid paths - redirect to shared */}
      <Route path="*" element={<Navigate to="/shared" replace />} />
    </Routes>
  );
}
